<div style="padding:24px 32px 0">
    <app-port-group-base-info [item]="data"></app-port-group-base-info>
    <app-port-group-resource [data]="data"></app-port-group-resource>
</div>
